window.addEventListener("DOMContentLoaded", () => {
    const urlParams = new URLSearchParams(window.location.search);
    const referral = urlParams.get('referral');
    if (!referral) return;
    fetch("/cart/update.js", {
        method: "POST",
        headers: {
            "content-type": "application/json",
        },
        body: JSON.stringify({
            attributes: {
                referral: referral
            },
            note:referral
        })
    });
})